import type { ComponentProps } from 'react';

const Search = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_105_43402)">
        <path
          d="M15.502 10.5011C15.502 9.1748 14.9751 7.90281 14.0372 6.96497C13.0994 6.02713 11.8274 5.50026 10.5011 5.50026C9.1748 5.50026 7.90281 6.02713 6.96497 6.96497C6.02713 7.90281 5.50026 9.1748 5.50026 10.5011C5.50026 11.8274 6.02713 13.0994 6.96497 14.0372C7.90281 14.9751 9.1748 15.502 10.5011 15.502C11.8274 15.502 13.0994 14.9751 14.0372 14.0372C14.9751 13.0994 15.502 11.8274 15.502 10.5011ZM14.5362 15.5989C13.4297 16.4771 12.0264 17.0022 10.5011 17.0022C6.90987 17.0022 4 14.0923 4 10.5011C4 6.90987 6.90987 4 10.5011 4C14.0923 4 17.0022 6.90987 17.0022 10.5011C17.0022 12.0264 16.4771 13.4297 15.5989 14.5362L19.7839 18.7213C20.0777 19.0151 20.0777 19.4901 19.7839 19.7808C19.4901 20.0715 19.0151 20.0746 18.7244 19.7808L14.5362 15.5989Z"
          fill="#8C98AB"
        />
      </g>
      <defs>
        <clipPath id="clip0_105_43402">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Search;
